import { Button, Flex, Text, rem, Image, Tooltip } from '@mantine/core'
import { Panorama360, PipelineParameters } from '../pipeline/Pipeline'
import { UploadCarPerspectiveButton } from '../pipeline/UploadCarPerspectiveButton'
import { useStore } from '../../../hooks/use-store'
import { observer } from 'mobx-react'
import { IconX } from '@tabler/icons-react'
import { priceMap } from '../pipeline/Router'

function Element(model: {
  buy: (params: PipelineParameters[]) => Promise<void>;
  loading: boolean
}) {
  const {
    dataStore: { spaceStore },
  } = useStore();

  // const [modelParams, setModelParams] = useState({
  //   prompt: '',
  //   topPrompt: '',
  //   bottomPrompt: '',
  //   negativePrompt: '',
  //   panorama_res: '4k',
  // });

  const handleRemoveImage = () => {
    spaceStore.setSelectedImage({ src: null });
  };

  return (
    <Flex w={'100%'} mt={12} pt={16} pb={16} pl={20} pr={20} style={{ borderRadius: '4px', background: 'rgba(32, 32, 32, 1)' }} gap={32}>
      <Flex direction={'column'} miw={'300px'} w={'300px'} gap={12}>
        <Text fz={20}>Image to 360</Text>

        {/* <Textarea
          w="100%"
          minRows={7}
          size="sm"
          label="Prompt"
          value={modelParams.prompt}
          description=""
          placeholder="Street view"
          onChange={(e) => {
            setModelParams({
              ...modelParams,
              prompt: e.currentTarget.value
            })
          }}
        />
        <Textarea
          w="100%"
          minRows={7}
          size="sm"
          label="Top prompt"
          value={modelParams.topPrompt}
          description=""
          placeholder="Street view"
          onChange={(e) => {
            setModelParams({
              ...modelParams,
              topPrompt: e.currentTarget.value
            })
          }}
        />
        <Textarea
          w="100%"
          minRows={7}
          size="sm"
          label="Bottom prompt"
          value={modelParams.bottomPrompt}
          description=""
          placeholder="Street view"
          onChange={(e) => {
            setModelParams({
              ...modelParams,
              bottomPrompt: e.currentTarget.value
            })
          }}
        />
        <Textarea
          w="100%"
          minRows={7}
          size="sm"
          label="Negative prompt"
          value={modelParams.negativePrompt}
          description=""
          placeholder="Street view"
          onChange={(e) => {
            setModelParams({
              ...modelParams,
              negativePrompt: e.currentTarget.value
            })
          }}
        /> */}
        {/* <Textarea
          w="100%"
          minRows={1}
          size="sm"
          label="Panorama resolution (4k, 8k, 16k)"
          value={modelParams.panorama_res}
          description=""
          placeholder="Street view"
          onChange={(e) => {
            setModelParams({
              ...modelParams,
              panorama_res: e.currentTarget.value
            })
          }}
        /> */}

        <UploadCarPerspectiveButton
          text={spaceStore.selectedImage ? "Re-upload image" : "Input image"}
          onSetImage={(image) => {
            spaceStore.setSelectedImage({
              src: image
            })
          }} />

        <Flex gap={12} mt={32} justify={'end'}>
          <Tooltip
            p={12}
            label={
              <span>Generation cost:
                &nbsp;
                <span style={{
                  color: '#f53c02',
                  fontWeight: 700
                }}>{priceMap.SHUTTER_IMAGE_360} credits
                </span>
              </span>
            }
            withArrow
            position="right"
            color='dark'
          >
            <Button
              styles={{
                root: {
                  color: 'rgba(230, 230, 230, 1)',
                  height: rem(36),
                  fontSize: '14px',
                  background: '#f53c02 !important',
                  border: 'none',
                  position: 'relative',
                }
              }}
              // disabled={modelParams.prompt.length === 0}
              variant="default"
              onClick={async () => {
                const pipeline: Panorama360 = {
                  provider: 'custom',
                  type: 'panorama360',
                  // prompt: modelParams.prompt,
                  // topPrompt: modelParams.topPrompt,
                  // bottomPrompt: modelParams.bottomPrompt,
                  // negativePrompt: modelParams.negativePrompt,
                  // panorama_res: modelParams.panorama_res,
                  inputSrc: spaceStore.selectedImage!,
                  srcset: [],
                  credits: priceMap.SHUTTER_IMAGE_360,
                }
                await model.buy([pipeline]);
              }}
            >
              Generate
            </Button>
          </Tooltip>
        </Flex>
      </Flex>

      {spaceStore.selectedImage && (
        <Flex direction="column" gap={8} style={{ flex: 1 }}>
          <Flex justify="space-between" align="center">
            <Text fz={20}>Preview</Text>
            <Button
              variant="subtle"
              color="red"
              size="xs"
              leftIcon={<IconX size={16} />}
              onClick={handleRemoveImage}
            >
              Remove
            </Button>
          </Flex>
          <Image
            src={spaceStore.selectedImage}
            alt="Selected image"
            style={{
              width: '100%',
              height: 'auto',
              maxHeight: '600px',
              objectFit: 'contain',
              borderRadius: '4px'
            }}
          />
        </Flex>
      )}
    </Flex>
  )
}

export const Shutter360ImageScreen = observer(Element);